import LocaleBulletedList from './LocaleBulletedList';

export default LocaleBulletedList;
